import { render, staticRenderFns } from "./CrossIcon.vue?vue&type=template&id=501ecf0a&"
import script from "./CrossIcon.vue?vue&type=script&lang=ts&"
export * from "./CrossIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('501ecf0a', component.options)
    } else {
      api.reload('501ecf0a', component.options)
    }
    module.hot.accept("./CrossIcon.vue?vue&type=template&id=501ecf0a&", function () {
      api.rerender('501ecf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/CrossIcon.vue"
export default component.exports